import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const savedLanguage = localStorage.getItem("onenizer-language");

const defaultLanguage =
  savedLanguage === "en" || savedLanguage === "de" ? savedLanguage : "de";

i18n.use(initReactI18next).init({
  resources: {
    de: {
      translation: require("../language/de.json"),
    },
    en: {
      translation: require("../language/en.json"),
    },
  },

  // Beim ersten Besuch immer Deutsch
  lng: defaultLanguage,

  // Wenn eine Übersetzung fehlt -> Deutsch
  fallbackLng: "de",

  supportedLngs: ["de", "en"],

  interpolation: {
    escapeValue: false,
  },
});

// Sprachwechsel automatisch speichern
i18n.on("languageChanged", (language) => {
  if (language === "de" || language === "en") {
    localStorage.setItem("onenizer-language", language);
  }
});

export default i18n;
